module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/0c361253f627ef4566a25cdf5e8ae160.png";